/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SafeDeleteResponse
 */
export interface SafeDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SafeDeleteResponse
     */
    status: boolean;
}

export function SafeDeleteResponseFromJSON(json: any): SafeDeleteResponse {
    return SafeDeleteResponseFromJSONTyped(json, false);
}

export function SafeDeleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDeleteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function SafeDeleteResponseToJSON(value?: SafeDeleteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}


